<mat-expansion-panel class="mc-expansion-panel" #expansionPanel hideToggle>
  <mat-expansion-panel-header
    class="mc-expansion-panel__header"
    [routerLink]="navItem.routerLink"
    (click)="onNavigate()"
  >
    <mat-panel-title class="mc-expansion-panel__header-title">
      <div class="mc-nav-item" [ngClass]="{'mc-nav-item_active': isActive, 'mc-nav-item_with-icon': navItem.icon}">
        <div class="mc-nav-item-wrap">
          @if (navItem.icon) {
            <mat-icon
              class="mc-nav-item__icon"
              svgIcon="{{ isActive && navItem.iconActive ? navItem.iconActive : navItem.icon }}"
              aria-hidden="true"
            ></mat-icon>
          }
          <span class="mc-nav-item__label">
            <span class="mc-nav-item__label__text">{{ navItem.label | translate }}</span>
          </span>
        </div>

        @if (navItem.labelIcon) {
          <mat-icon
            svgIcon="{{ isActive ? navItem.labelIconActive : navItem.labelIcon }}"
            class="mc-nav-item__label-icon"
            aria-hidden="true"
          ></mat-icon>
        }

        <span class="mc-expansion-panel__header-title-btn__arrow" [ngClass]="{'is-opened': expansionPanel.expanded}">
          <mat-icon svgIcon="triangle_right" aria-hidden="true"></mat-icon>
        </span>
      </div>
    </mat-panel-title>
    <mat-panel-description><ng-content select="[description]"></ng-content></mat-panel-description>
    <ng-content select="[toggle]"></ng-content>
  </mat-expansion-panel-header>
  <div class="mc-expansion-panel__body">
    <ng-content select="[body]"></ng-content>
  </div>
</mat-expansion-panel>
